module.exports = __webpack_public_path__ + "img/iot_n.61f24fd5.svg";